import React from 'react';

import { Checkbox as AntCheckbox, CheckboxProps } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox';
import classNames from 'classnames';

import styles from './Checkbox.module.less';

interface CheckboxType extends CheckboxProps {
    label?: CheckboxProps['children'];
}

export const Checkbox = ({ label, disabled, ...props }: CheckboxType) => {
    return (
        <AntCheckbox
            className={styles.Container}
            disabled={disabled}
            {...props}
        >
            <div
                className={classNames(styles.Label, {
                    [styles.Label__Disabled]: disabled
                })}
                data-testid="CheckboxLabel"
            >
                {label}
            </div>
        </AntCheckbox>
    );
};

type CheckboxGroupType = CheckboxGroupProps;

export const CheckboxGroup = ({ children, ...props }: CheckboxGroupType) => {
    return <AntCheckbox.Group {...props}>{children}</AntCheckbox.Group>;
};
